export default __webpack_public_path__ + "static/img/Letinte71.dfac359.jpg";